import { render, staticRenderFns } from "./EditRmaModal.vue?vue&type=template&id=a3115612&"
import script from "./EditRmaModal.vue?vue&type=script&lang=js&"
export * from "./EditRmaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports